const BOOLEAN_APPEARANCE_KEYS = [
  'header_fade',
  'show_logo',
  'show_ask_card',
  'show_articles',
  'show_agent_avatars',
  'show_ai_badge',
  'show_tab_home',
  'show_tab_messages',
  'show_tab_help',
  'show_tab_news',
];

const toBool = value => value === true || value === 'true';

export const DEFAULT_WIDGET_APPEARANCE = {
  layout: 'intercom',
  header_style: 'gradient',
  header_color: null,
  header_gradient_end: null,
  header_fade: true,
  show_logo: true,
  show_ask_card: true,
  show_articles: true,
  show_agent_avatars: true,
  show_ai_badge: true,
  show_tab_home: true,
  show_tab_messages: true,
  show_tab_help: true,
  show_tab_news: true,
  bubble_position: 'right',
  bubble_type: 'standard',
  bubble_launcher_title: '',
};

export const mergeWidgetAppearance = (appearance = {}) => {
  const merged = {
    ...DEFAULT_WIDGET_APPEARANCE,
    ...appearance,
  };
  BOOLEAN_APPEARANCE_KEYS.forEach(key => {
    if (key in merged) merged[key] = toBool(merged[key]);
  });
  return merged;
};

export { normalizeStorageUrl } from './storageUrl';

export const applyWidgetAppearanceToDocument = (appearance, widgetColor) => {
  const merged = mergeWidgetAppearance(appearance);
  const headerColor = merged.header_color || widgetColor;
  const gradientEnd = merged.header_gradient_end || headerColor;
  const primaryColor = widgetColor || headerColor;

  const root = document.documentElement;
  root.style.setProperty('--widget-header-color', headerColor);
  root.style.setProperty('--widget-header-gradient-end', gradientEnd);
  root.style.setProperty('--widget-primary-color', primaryColor);
  root.dataset.widgetLayout = merged.layout;
  root.dataset.widgetHeaderFade = merged.header_fade ? 'true' : 'false';
};

export const headerStyleOptions = [
  { value: 'solid', labelKey: 'INBOX_MGMT.WIDGET_BUILDER.APPEARANCE.HEADER_STYLE.SOLID' },
  {
    value: 'gradient',
    labelKey: 'INBOX_MGMT.WIDGET_BUILDER.APPEARANCE.HEADER_STYLE.GRADIENT',
  },
];
